export class ChangePassword {
  OldPassword: string;
  NewPassword: string;
  ConfirmPassword: string;

  constructor() {
    this.OldPassword = null;
    this.NewPassword = null;
    this.ConfirmPassword = null;
  }
}
